// Why an UploadAsset failed. A typed code (not a free-form string) so the app
// can map it to its own (localised) message or handle cases differently.
export var AssetUploadError;
(function (AssetUploadError) {
    AssetUploadError["TooLarge"] = "too_large";
    AssetUploadError["Failed"] = "upload_failed";
})(AssetUploadError || (AssetUploadError = {}));
// How long the SDK waits for an AssetUploadResult before failing the upload.
// Hosts that predate UploadAsset never reply, and large uploads can be slow,
// so this is generous rather than snappy.
export const ASSET_UPLOAD_TIMEOUT_MS = 60000;
export var UserRole;
(function (UserRole) {
    UserRole["HOST"] = "HOST";
    UserRole["PARTICIPANT"] = "PARTICIPANT";
})(UserRole || (UserRole = {}));
